import type { Filter } from '../types';
import { apiClient } from './client';

interface FiltersResponse {
  contentFilters: Record<string, boolean>;
  availableFilters: Filter[];
  filtersByCategory: Record<string, Filter[]>;
}

export const filtersApi = {
  getFilters: async (guildId: string): Promise<Filter[]> => {
    const response = await apiClient.get<FiltersResponse>(`/guilds/${guildId}/filters`);
    
    // availableFilters를 사용하고, contentFilters의 enabled 상태를 반영
    const filters = response.data.availableFilters.map(filter => ({
      ...filter,
      enabled: response.data.contentFilters[filter.id] ?? filter.enabled,
    }));
    
    return filters;
  },

  toggleFilter: async (guildId: string, filterId: string, enabled: boolean): Promise<Filter> => {
    const response = await apiClient.patch<Filter>(
      `/guilds/${guildId}/filters/${filterId}`,
      { enabled }
    );
    return response.data;
  },
};
